/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import * as styles from './bio.module.css';

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 50, height: 50)
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            facebook
            instagram
          }
        }
      }
    }
  `);

  const { author, social } = data.site.siteMetadata;
  return (
    <div
      style={{
        display: `flex`,
        marginBottom: 0,
      }}
    >
      <GatsbyImage
        image={data.avatar.childImageSharp.gatsbyImageData}
        alt={author.name}
        loading="lazy" // 启用懒加载
        decoding="async"
        style={{
          marginRight: 14,
          marginBottom: 0,
          minWidth: 50,
          borderRadius: `100%`,
        }}
        imgStyle={{
          borderRadius: `50%`,
        }}
      />
      <div>
        <strong>{author.name}</strong> {author.summary}
        <div className={styles.socialIcons}>
          {' '}
          Follow me on
          <a href={`https://facebook.com/${social.facebook}`} target="_blank" rel="noreferrer">
            <IconButton color="primary" aria-label="facebook" size="large">
              <FacebookIcon />
            </IconButton>{' '}
          </a>
          <a href={`https://instagram.com/${social.instagram}`} target="_blank" rel="noreferrer">
            <IconButton color="primary" aria-label="instagram" size="large">
              <InstagramIcon />
            </IconButton>{' '}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Bio;
